import React from 'react'
import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
  //eslint-disable-next-line
  NextLink,
  RequestHandler,
  Operation,
} from '@apollo/client'
import { MultiAPILink } from '@habx/apollo-multi-endpoint-link'
import { onError } from '@apollo/client/link/error'
import { RestLink } from 'apollo-link-rest'
import axios from 'axios'
import { createUploadLink } from 'apollo-upload-client'
// import { getMainDefinition } from "apollo-utilities"

// import Cookies from 'universal-cookie'

// import { ApolloLink, split } from 'apollo-link'

const useApollo = () => {
  const apollo = React.useMemo(
    () => {
      const logout = async () => {
        await axios({
          method: 'POST',
          url: `${process.env.REACT_APP_ACCOUNTS_URL}/auth/logout`,
          withCredentials: true,
        })
        if (window.location.pathname !== '/login') {
          window.location.href = '/login'
        }
      }

      const errorLink = onError((context) => {
        const { graphQLErrors, networkError }: any = context
        // debugger
        if (graphQLErrors) {
          graphQLErrors.map(({ message, locations, path, extensions }: any) => {
            if (extensions?.exception?.status === 401) {
              logout()
            }

            // if(extensions?.exception?.status === 403){
            //   logout()
            // }
            return true
          })
        }

        if (networkError && networkError.statusCode === 401) {
          logout()
        }

        // if(networkError && networkError.statusCode === 403){
        //   logout()
        // }
      })

      const mLink = new MultiAPILink({
        endpoints: {
          vehicle: `${process.env.REACT_APP_VEHICLEDATA_URL}`,
          project: `${process.env.REACT_APP_SERVICES_URL}`,
          region: `https://service-data-staging.betterfleet.com`,
        },
        createHttpLink: () => createHttpLink({}),
        getContext: (endpoint) => {
          if (endpoint === 'project') {
            return {
              credentials: 'include',
              // headers:{ accounttype: accountType },
            }
          }
          return {}
        },
      })

      const requestHandler: RequestHandler = (operation: Operation, forward: NextLink): any => {
        operation.setContext(({ headers }: any) => {
          let credentials: any = 'include'
          if (
            [
              'registration',
              'resendCode',
              'forgotPassword',
              'resetPassword',
              'resendVerifyEmail',
              'activateAccount',
              'verifyEmail',
            ].includes(operation.operationName)
          ) {
            credentials = null
          }
          return {
            credentials,
          }
        })
        return forward(operation)
      }

      const authRestLink = new ApolloLink(requestHandler)

      const restLink = new RestLink({
        endpoints: {
          vehicle: `${process.env.REACT_APP_CALCULATE_SERVICE_URL}/v1.0`,
          project: `${process.env.REACT_APP_SERVICES_URL}`,
        },
        typePatcher: {
          SensitivityAnalysisMulti: (data) => ({ data: Object.values(data).filter(Boolean) }),
          SensitivityAnalysis: (data) => ({ data: Object.values(data).filter(Boolean) }),
        },
        headers: {
          'Content-Type': 'application/json',
          // accountType: accountType,
          // origin: 'https://service-tco-dev.evenergi.com'
        },
        // credentials: 'include',
      })

      const uploadLink: any = createUploadLink({
        uri: `${process.env.REACT_APP_SERVICES_URL}/graphql`,
        credentials: 'include',
      })

      const apolloLink = ApolloLink.from([
        errorLink,
        authRestLink,
        ApolloLink.from([restLink, mLink, uploadLink]),
      ])

      return new ApolloClient({
        link: apolloLink,
        cache: new InMemoryCache(),
        defaultOptions: {
          watchQuery: {
            fetchPolicy: 'cache-and-network',
          },
          query: {
            fetchPolicy: 'cache-first',
            errorPolicy: 'all',
          },
          mutate: {
            errorPolicy: 'all',
          },
        },
      })
    },
    [], // eslint-disable-line
  )

  return apollo
}

export default useApollo
